import React from 'react';
import { InfoTooltip } from '@/views/components/tooltips';
import classNames from 'classnames';

type TooltipHeaderCellProps = {
  label: React.ReactNode;
  tooltipTitle?: string;
  tooltipMessage: string;
  className?: string;
};

const TooltipHeaderCell: React.FC<TooltipHeaderCellProps> = ({ label, tooltipTitle, tooltipMessage, className }) => (
  <span className={classNames('cell tooltip-header-cell', className)}>
    {label}
    <InfoTooltip title={tooltipTitle} message={tooltipMessage} />
  </span>
);

export default TooltipHeaderCell;
